/* MJ Creations · theme.js — cart drawer, AJAX cart, free-ship bar, toast */
(function () {
  var CFG = window.MJ || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- money ---------- */
  function money(cents) {
    var fmt = CFG.money_format || '${{amount}}';
    var val = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, val.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(cents / 100))
      .replace(/<[^>]+>/g, '');
  }

  /* ---------- toast ---------- */
  var toastEl = $('#mjToast');
  window.MJToast = function (msg) {
    if (!toastEl) return;
    toastEl.innerHTML = msg;
    toastEl.classList.add('is-show');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-show'); }, 2200);
  };

  /* ---------- drawer ---------- */
  var drawer = $('#mjDrawer'), scrim = $('#mjScrim');
  // The drawer is only slid off-screen with a transform, so `aria-hidden` alone leaves its
  // close button, quantity steppers and checkout link sitting in the tab order while they
  // are invisible. `inert` is the attribute that actually removes them (WCAG 4.1.2 / 2.4.3).
  // Closing also returns focus to the trigger so the visitor does not get dropped at the
  // top of the document.
  var drawerOpener = null;
  function openDrawer(trigger) {
    if (drawer) { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); drawer.removeAttribute('inert'); }
    if (scrim) scrim.classList.add('is-open');
    // openDrawer is also used as a promise callback (fetchCart().then(openDrawer)), which
    // would hand us the cart object — only remember a real element to return focus to.
    drawerOpener = (trigger && typeof trigger.focus === 'function') ? trigger : null;
  }
  function closeDrawer() {
    var wasOpen = drawer && drawer.classList.contains('is-open');
    if (drawer) { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); drawer.setAttribute('inert', ''); }
    if (scrim) scrim.classList.remove('is-open');
    if (wasOpen && drawerOpener) { try { drawerOpener.focus(); } catch (e) {} }
    drawerOpener = null;
  }
  if (drawer && !drawer.classList.contains('is-open')) drawer.setAttribute('inert', '');
  $$('[data-cart-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openDrawer(b); }); });
  $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', function () { closeDrawer(); }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* ---------- render cart ---------- */
  var body = $('#mjDrawerBody'), totalEl = $('#mjDrawerTotal'),
      shipMsg = $('#mjShipMsg'), shipFill = $('#mjShipFill');
  var FREE = CFG.free_shipping || 0;

  function renderCart(cart) {
    // Guard the shared sink: a cart-error body ({status,message,description}) or a null from a
    // swallowed fetch has no item_count, and painting `undefined` into the bubble is worse
    // than leaving the last good value in place.
    if (!cart || typeof cart.item_count !== 'number') return;
    $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    if (totalEl) totalEl.textContent = money(cart.total_price);

    if (shipMsg && FREE > 0) {
      var left = Math.max(0, FREE - cart.total_price);
      shipMsg.innerHTML = left > 0
        ? (CFG.strings && CFG.strings.ship_left ? CFG.strings.ship_left.replace('%AMT%', money(left)) : "You're " + money(left) + ' away from a free gift wrap')
        : (CFG.strings && CFG.strings.ship_done ? CFG.strings.ship_done : 'Gift wrap unlocked 🎀');
      if (shipFill) shipFill.style.width = Math.min(100, cart.total_price / FREE * 100) + '%';
    }

    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<div class="t-drawer__empty">' + (body.dataset.empty || '') + '</div>';
      var ub = document.getElementById('mjUpsell');
      if (ub) { ub.hidden = true; ub.innerHTML = ''; ub.dataset.for = ''; }
      return;
    }
    body.innerHTML = cart.items.map(function (i) {
      var props = '';
      if (i.properties) {
        Object.keys(i.properties).forEach(function (k) {
          if (k.charAt(0) !== '_' && i.properties[k]) props += k + ': ' + i.properties[k] + ' ';
        });
      }
      var sub = (i.variant_title && i.variant_title !== 'Default Title') ? i.variant_title : '';
      var img = i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : '';
      return '<div class="t-line-item">' +
        (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
        '<div><div class="n">' + i.product_title + '</div>' +
        '<div class="v">' + (sub || '') + ' × ' + i.quantity + '</div>' +
        (props ? '<div class="v t-line-props">' + props.trim() + '</div>' : '') +
        '<button class="t-line-remove" data-remove="' + i.key + '">' + (CFG.strings && CFG.strings.remove || 'Remove') + '</button></div>' +
        '<div class="p">' + money(i.final_line_price) + '</div>' +
        '</div>';
    }).join('');

    $$('[data-remove]', body).forEach(function (b) {
      b.addEventListener('click', function () { changeQty(b.dataset.remove, 0); });
    });
    renderUpsell(cart);
  }

  /* ---------- cart cross-sell (Completes the look) ---------- */
  function renderUpsell(cart) {
    var box = document.getElementById('mjUpsell');
    if (!box || CFG.cart_upsell === false || !cart.items.length) { if (box) box.hidden = true; return; }
    var pid = cart.items[0].product_id;
    if (box.dataset.for === String(pid)) return;
    box.dataset.for = String(pid);
    var inCart = {}; cart.items.forEach(function (i) { inCart[i.product_id] = 1; });
    var root = (CFG.routes && CFG.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    fetch(root + 'recommendations/products.json?product_id=' + pid + '&limit=8&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var rec = (d.products || []).filter(function (p) { return !inCart[p.id] && p.available; })[0];
        if (!rec) { box.hidden = true; box.innerHTML = ''; return; }
        var v = (rec.variants || []).filter(function (x) { return x.available; })[0] || (rec.variants || [])[0];
        if (!v) { box.hidden = true; return; }
        var raw = String(v.price);
        var cents = raw.indexOf('.') > -1 ? Math.round(parseFloat(raw) * 100) : parseInt(raw, 10);
        var img = rec.featured_image || (rec.images && rec.images[0]) || '';
        if (img) img = img.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2');
        box.innerHTML =
          '<div class="t-upsell">' +
          (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
          '<div class="t-upsell__info">' +
          '<div class="t-upsell__label">' + (CFG.strings && CFG.strings.completes || 'Completes the look') + '</div>' +
          '<a class="t-upsell__name" href="' + root + 'products/' + rec.handle + '">' + rec.title + '</a>' +
          '<div class="t-upsell__price">' + money(cents) + '</div></div>' +
          '<button type="button" class="t-upsell__add" data-add-variant="' + v.id + '">' + (CFG.strings && CFG.strings.add || 'Add') + '</button>' +
          '</div>';
        box.hidden = false;
        box.querySelectorAll('[data-add-variant]').forEach(function (b) {
          b.addEventListener('click', function (e) { e.preventDefault(); window.MJCart.addVariant(b.dataset.addVariant, 1); });
        });
      })
      .catch(function () { box.hidden = true; });
  }

  // fetchCart() runs on every page load. An ad-blocker, a privacy extension, a flaky mobile
  // connection, a Shopify throttle or simply navigating away mid-request rejects the fetch —
  // without a .catch() that became an unhandled rejection on the visitor's pageview. The cart
  // UI is non-critical, so swallow it and resolve to null; callers must tolerate null.
  function fetchCart() {
    return fetch(CFG.routes.cart + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; })
      .catch(function () { return null; });
  }

  function changeQty(key, qty) {
    return fetch(CFG.routes.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart)
      .catch(function () { window.MJToast(CFG.strings && CFG.strings.error || 'Something went wrong. Please try again.'); });
  }

  /* ---------- add to cart ---------- */
  window.MJCart = {
    open: openDrawer,
    refresh: fetchCart,
    addFromForm: function (form) {
      var data = new FormData(form);
      // drop empty line-item properties so the order stays clean in the dashboard
      var empties = [];
      data.forEach(function (v, k) { if (k.indexOf('properties[') === 0 && String(v).trim() === '') empties.push(k); });
      empties.forEach(function (k) { data.delete(k); });
      return fetch(CFG.routes.cart_add, { method: 'POST', headers: { 'Accept': 'application/json' }, body: data })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { window.MJToast(res.description || res.message); return; }
          window.MJToast(CFG.strings && CFG.strings.added || 'Added to cart');
          var atc = form.querySelector('[data-atc]');
          if (atc) { atc.classList.add('is-added'); setTimeout(function () { atc.classList.remove('is-added'); }, 900); }
          return fetchCart().then(openDrawer);
        })
        .catch(function () { window.MJToast(CFG.strings && CFG.strings.error || 'Something went wrong. Please try again.'); });
    },
    addVariant: function (id, qty) {
      return fetch(CFG.routes.cart_add, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: id, quantity: qty || 1 })
      }).then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { window.MJToast(res.description || res.message); return; }
          window.MJToast(CFG.strings && CFG.strings.added || 'Added to cart');
          return fetchCart().then(openDrawer);
        })
        .catch(function () { window.MJToast(CFG.strings && CFG.strings.error || 'Something went wrong. Please try again.'); });
    }
  };

  /* ---------- quick-add buttons (editorial "shop the look") ---------- */
  $$('[data-add-variant]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      if (!b.dataset.addVariant) return;
      window.MJCart.addVariant(b.dataset.addVariant, 1);
    });
  });

  /* ---------- fabric-fade scroll reveal (The Thread motion) ---------- */
  /* Resting state is VISIBLE. JS adds .mj-reveal only when it can guarantee to reveal,
     so a JS failure or reduced-motion never hides content. */
  (function () {
    var targets = $$('[data-reveal]');
    if (!targets.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isHome = document.body.classList.contains('template-index');
    var designMode = window.Shopify && window.Shopify.designMode;
    // Only ever hide/animate on the homepage, with motion allowed, and NOT inside
    // the theme editor. Everywhere else content stays visible (never stuck hidden).
    if (!isHome || reduce || designMode || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    targets.forEach(function (el) {
      el.classList.add('mj-reveal');
      // stagger children marked with data-reveal-child
      var kids = el.querySelectorAll('[data-reveal-child]');
      for (var i = 0; i < kids.length; i++) {
        kids[i].style.setProperty('--i', Math.min(i, 6));
      }
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          var el = en.target;
          el.classList.add('is-in');
          io.unobserve(el);
          // self-clean stagger so it never bleeds into hover transitions
          setTimeout(function () {
            var kids = el.querySelectorAll('[data-reveal-child]');
            for (var j = 0; j < kids.length; j++) { kids[j].style.removeProperty('--i'); }
          }, 1400);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    targets.forEach(function (el) { io.observe(el); });
    // fail-safe: reveal anything still hidden ~2.5s after load
    window.addEventListener('load', function () {
      setTimeout(function () {
        targets.forEach(function (el) { if (!el.classList.contains('is-in')) el.classList.add('is-in'); });
      }, 2500);
    });
  })();

  /* ---------- collection infinite scroll ---------- */
  /* Progressive enhancement: numbered pagination is the no-JS fallback. When JS runs,
     it hides the numbered nav and appends the next page as the shopper scrolls. */
  (function () {
    var grid = $('[data-infinite-grid]');
    if (!grid) return;
    var zone = $('[data-infinite-zone]');
    var moreBtn = $('[data-infinite-more]');
    var sentinel = $('[data-infinite-sentinel]');
    var numbered = $('[data-infinite-pagination]');
    if (numbered) numbered.style.display = 'none'; // JS takes over paging
    var nextUrl = grid.getAttribute('data-next-url') || '';
    var loading = false, done = !nextUrl;

    function finish() { done = true; if (zone) zone.parentNode && zone.parentNode.removeChild(zone); }

    function load() {
      if (loading || done || !nextUrl) return;
      loading = true;
      if (moreBtn) { moreBtn.classList.add('is-loading'); moreBtn.disabled = true; }
      fetch(nextUrl, { headers: { 'X-Requested-With': 'fetch' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nextGrid = doc.querySelector('[data-infinite-grid]');
          if (nextGrid && nextGrid.children.length) {
            var frag = document.createDocumentFragment();
            Array.prototype.slice.call(nextGrid.children).forEach(function (c) {
              frag.appendChild(document.importNode(c, true));
            });
            grid.appendChild(frag);
            nextUrl = nextGrid.getAttribute('data-next-url') || '';
          } else { nextUrl = ''; }
          loading = false;
          if (moreBtn) { moreBtn.classList.remove('is-loading'); moreBtn.disabled = false; }
          if (!nextUrl) finish();
        })
        .catch(function () {
          loading = false;
          if (moreBtn) { moreBtn.classList.remove('is-loading'); moreBtn.disabled = false; }
        });
    }

    if (moreBtn) moreBtn.addEventListener('click', load);
    if ('IntersectionObserver' in window && sentinel) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) load(); });
      }, { rootMargin: '800px 0px' });
      io.observe(sentinel);
    }
  })();

  /* ---------- initial paint ---------- */
  fetchCart();
})();
